import i18n from 'i18next';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';
import { checkServiceProvider } from './serviceProviderConfig';

export const allTabs = [
  { name: 'Unassigned', key: 'unassignedInspections' },
  { name: 'Pending Mechanic', key: 'pendingMechanicInspections' },
  { name: 'Pending Driver', key: 'pendingDriverInspections' },
  { name: 'Completed', key: 'completedInspections' },
  { name: 'No Defect', key: ' noDefectInspections' },
];

export const sortColumnMapping = {
  unitId: 'vehicleName',
  work_order_id: 'idPub',
  type: 'unitType',
  reported_date: 'createDate',
  scheduled_date: 'beginDate',
  due_date: 'endDate',
  workOrderType: 'type',
  status: 'state',
};

export const basicRequest = {
  displayLength: checkServiceProvider('config_displayLength', window.$environment.SERVICE_PROVIDER, false),
  displayStart: '1',
};

export const columns = [
  {
    id: 'work_order_id',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.workOrderId'),
  },
  {
    id: hasRestrictedRole([ROLES.SERVICE_MANAGER, 'MECHANIC']) ? 'companyName' : 'serviceCenterName',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: hasRestrictedRole([ROLES.SERVICE_MANAGER, 'MECHANIC'])
      ? i18n.t('workOrders.company')
      : i18n.t('workOrders.serviceCenter'),
  },
  {
    id: 'unitId',
    numeric: false,
    disablePadding: false,
    needSorting: false,
    label: i18n.t('vehicles.vin'),
  },
  {
    id: 'mechanicName',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('common.mechanic'),
  },
  {
    id: 'driverName',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('common.driver'),
  },
  {
    id: 'unitType',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.unitType'),
  },
  {
    id: 'reported_date',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.reportedDate'),
  },
  {
    id: 'scheduled_date',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.scheduledDate'),
  },
  {
    id: 'due_date',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.dueDate'),
  },
  {
    id: 'workOrderType',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.serviceType'),
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('Status'),
  },
  {
    id: 'overDue',
    numeric: false,
    disablePadding: false,
    needSorting: false,
    label: '',
  },
  {
    id: 'report',
    numeric: false,
    needSorting: false,
    disablePadding: false,
    label: '',
  },
];

export const formattedType = {
  TRACTOR_DAY_CAB: 'Tractor Day Cab',
  TRACTOR_SLEEPER: 'Tractor Sleeper',
  BOBTAIL: 'Bobtail',
  STRAIGHT_TRUCK: 'Straight Truck',
  BOX_TRUCK: 'Box Truck',
  PICKUP: 'Pickup',
  PRIVATE_PASSENGER: 'Private Passenger',
  VACUUM: 'Vacuum',
  VAN: 'Van',
  OTHER: 'Other',
};

export const downloadTypes = [
  { label: 'DVIR', value: 'DVIR' },
  { label: 'POST-TRIP', value: 'POST_TRIP' },
  { label: 'PRE-TRIP', value: 'PRE_TRIP' },
];
